import React from 'react';
import { InputField } from 'vindi-ds-components';

function CustomerEmailField() {
  return (
    <InputField
      placeholder='Digite seu melhor email'
      label='E-mail'
      name='email'
    />
  );
}

export default CustomerEmailField;
